export function travelPackageDefaults(answers = {}) {
  const modes = Array.isArray(answers.travel_modes) ? [...answers.travel_modes] : [];
  if (answers.flight_class && !modes.includes("Flight")) modes.push("Flight");
  if (answers.train_class && !modes.includes("Train")) modes.push("Train");
  const legacyPolicy = {
    Customer: "Customer pays actual expenses",
    "I include travel charges in my package": "Included in package",
  }[answers.travel_who_pays];
  const partySize = answers.travel_party_size === "Only me"
    ? 1
    : Number.parseInt(String(answers.travel_party_size || "").replace("+", ""), 10) || "";
  const willTravelOutstation = answers.travel_scope
    ? answers.travel_scope !== "Only within my city"
    : modes.length > 0;

  return {
    travel_required: willTravelOutstation,
    accommodation_required: ["Always", "Only for outstation events"].includes(answers.hotel_required),
    travel_modes: modes,
    flight_class: answers.flight_class || "",
    train_class: answers.train_class || "",
    hotel_category: answers.hotel_category || "",
    team_size: partySize,
    travel_charge_model: answers.travel_charge_model || legacyPolicy || "",
    travel_flat_fee: answers.travel_flat_fee ?? "",
    travel_free_distance_km: answers.travel_free_distance_km ?? "",
    travel_per_km_fee: answers.travel_per_km_fee ?? "",
    travel_notes: answers.travel_notes || "",
  };
}